module.exports = __webpack_public_path__ + "static/media/QR code.d401c897.jpeg";